<template>
  <div v-if="isShowLive">
    <!--        移动端-->
    <div v-if="isMobile" class="mobile-course-live-online-container">
      <!--直播课程-->
      <div class="mobile-live-list-container">
        <div class="first-line">
          <div class="title-box">
            <img src="@assets/img/index/live-broadcast-icon.png" alt="">
            <div>直播课程</div>
            <div>互联网大佬在线直播</div>
          </div>
          <div class="live-next-last-box">
            <img @click="liveTurnPage('last')"
                 :src="livePageParams.pageNum==1?imageMap.lastGeryArrow:imageMap.lastGreenArrow" alt="">
            <img @click="liveTurnPage('next')"
                 :src="livePageParams.total>livePageParams.pageNum*4?imageMap.nextGreenArrow:imageMap.nextGeryArrow"
                 alt="">
          </div>
        </div>
        <a-row :gutter="12">
          <a-col :span="12" @click="toLiveOnlineDetail(item.courseId)" v-for="(item) in liveOnlineList"
                 :key="item.courseId">
            <div class="live-content-box">
              <div class="img-box hover-img-scale-box">
                <img :src="item.course.coverFileUrl" alt="">
              </div>
              <div>
                {{ item.course.courseTitle }}
              </div>
              <div v-if="item.liveStatus == 1" class="progress-box">
                <img src="@assets/img/index/progress.gif" alt="">
                {{ buttonText(item.liveStatus) }}
              </div>
              <div v-else-if="item.liveStatus == 2" class="end-box">
                <a-icon type="check-circle" style="margin-right: 3px"/>
                {{ buttonText(item.liveStatus) }}
              </div>
              <div v-else class="not-start-box">
                <a-icon type="play-circle" style="margin-right: 3px"/>
                <span>  {{
                    item.nextStartTime | formatDate("MM-DD HH:mm")
                  }}</span>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
      <!--课程榜单-->
      <div class="mobile-course-top-list">
        <div class="online-right">
          <div class="title-box">
            <img src="@assets/img/index/trophy-icon.png" alt="">
            <div>课程榜单</div>
          </div>
          <div class="content-box" >
            <!--                左侧图片-->
            <img src="@assets/img/index/bestseller-list.png" alt="畅销榜图片">
            <!--                右侧价格、名称-->
            <div class="course-box">
              <router-link :to=" {name:'courseDetail',params: { courseId: item.courseId }}" target="_blank" class="list-item"
                           v-for="(item,index) in currentDisplayList" :key="item.courseId">
                {{item.courseType}}

                <div  class="left-num" :style="{backgroundColor:displayColor(index)}">NO.{{ item.index }}</div>
                <!--                    <div :style="{backgroundImage:`url(${item.bannerFileUrl})`,}"></div>-->
                  <img :src="item.bannerFileUrl" alt="">
                <div class="">
                  <div>
                    {{ item.courseTitle }}
                  </div>
                  <div>
                    ¥{{ $func.isTrue(item.isDiscount)?item.discountPrice:item.coursePrice }}
                  </div>
                  <div>
                    {{ item.participationsCount }} 人报名
                  </div>
                </div>
              </router-link>
            </div>
            <button class="change-box" @click="changeIndex">换一换</button>
          </div>

        </div>

      </div>
    </div>

    <!--        PC端-->
    <div v-else class="box course-live-online-container">
      <div>
        <a-row :gutter='16'>
<!--         直播课程 -->
          <a-col :span="14">
            <div class="online-left">
              <!--                          第一行直播课程-->
              <div class="first-line">
                <div class="title-box">
                  <img src="@assets/img/index/live-broadcast-icon.png" alt="">
                  <div>直播课程</div>
                  <div>互联网大佬在线直播</div>
                </div>
                <div class="live-next-last-box">
                  <img @click="liveTurnPage('last')"
                       :src="livePageParams.pageNum==1?imageMap.lastGeryArrow:imageMap.lastGreenArrow" alt="">
                  <img @click="liveTurnPage('next')"
                       :src="livePageParams.total>livePageParams.pageNum*4?imageMap.nextGreenArrow:imageMap.nextGeryArrow"
                       alt="">
                </div>
              </div>
              <a-row :gutter="20">
                <a-col :span="12" @click="toLiveOnlineDetail(item.courseId)" v-for="(item) in liveOnlineList"
                       :key="item.courseId">
                  <div class="live-content-box">
                    <div class="hover-img-scale-box">
                      <img :src="item.course.coverFileUrl" alt="">
                    </div>
                    <div>
                      {{ item.course.courseTitle }}
                    </div>
                    <div v-if="item.liveStatus == 1" class="progress-box">
                      <img src="@assets/img/index/progress.gif" alt="">
                      {{ buttonText(item.liveStatus) }}
                    </div>
                    <div v-else-if="item.liveStatus == 2" class="end-box">
                      <a-icon type="check-circle" style="margin-right: 3px"/>
                      {{ buttonText(item.liveStatus) }}
                    </div>
                    <div v-else class="not-start-box">
                      <a-icon type="play-circle" style="margin-right: 3px"/>
                      <span>  {{
                          item.nextStartTime | formatDate("MM-DD HH:mm")
                        }}</span>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-col>
<!--          榜单-->
          <a-col :span="10">
            <div class="online-right">
              <div class="title-box">
                <img src="@assets/img/index/trophy-icon.png" alt="">
                <div>课程榜单</div>
                <div>以购买、学习相关数据为依据～每日更新</div>
              </div>
              <div class="content-box">
                <!--                左侧图片-->
                <img src="@assets/img/index/bestseller-list.png" alt="畅销榜图片">
                <!--                右侧价格、名称-->
                <div class="course-box">
                  <div  @click="jumpDetail(item.courseId)" v-for="(item,index) in currentDisplayList" :key="item.courseId">
                    <div class="left-num" :style="{backgroundColor:displayColor(index)}">NO.{{ item.index }}</div>
                    <!--                    <div :style="{backgroundImage:`url(${item.bannerFileUrl})`,}"></div>-->
                    <div class="hover-img-scale-box">
                      <img :src="item.bannerFileUrl" alt="">
                    </div>
                    <div class="title-price-box">
                      <div>
                        {{ item.courseTitle }}
                      </div>
                      <div>
                        ¥{{ $func.isTrue(item.isDiscount)?item.discountPrice:item.coursePrice }}
                      </div>
                      <div>
                        {{ item.participationsCount }} 人报名
                      </div>
                    </div>
                  </div>
                </div>
                <button class="change-box" @click="changeIndex">换一换</button>
              </div>

            </div>
          </a-col>
        </a-row>
      </div>
    </div>

  </div>
</template>

<script>
import {liveCourseInfoList} from "@api/course-live-online"
import common from "../../../mixin/common";
import {SUCCESS} from "@constants/code";
import lastGeryArrow from '@assets/img/index/last-arrow.png'
import nextGreenArrow from '@assets/img/index/next-green-arrow.png'
import nextGeryArrow from '@assets/img/index/next-grey-icon.png'
import lastGreenArrow from '@assets/img/index/last-green-arrow.png'
import {debounce} from "ant-design-vue/lib/vc-table/src/utils";
import {getCourseTopList} from "@api/course-api";

export default {
  name: "CourseLiveOnline",
  mixins: [common],
  data() {
    return {
      // 上一页下一页图片静态资源
      imageMap: {
        lastGeryArrow, nextGreenArrow, nextGeryArrow, lastGreenArrow
      },
      // 榜单当前展示数据
      currentDisplayList: [],
      currentIndex: 0,
      topList: [],
      //显示直播课程
      showLive: true,
      //按钮文本
      activeIndex: 0,
      //右侧直播课程列表
      liveOnlineList: [],
      backgroundImg: "",
      livePageParams: {
        pageNum: 1,
        pageSize: 4,
        total: 0
      }
    }
  },
  computed: {

    // 是否展示直播模块
    isShowLive() {
      return this.liveOnlineList.length > 0;
    },
    activeCourse() {
      return this.liveOnlineList[this.activeIndex];
    },
  },
  created() {
    // 加载直播可成列表
    this.getLiveList()
    this.getTopList()
  },
  methods: {
    jumpDetail(courseId){
      const {href} = this.$router.resolve({name:'courseDetail',params: { courseId: courseId }});
      window.open(href, '_blank');

    },
    displayColor(index){
      switch (index) {
        case 0:
          return "#fc8b33"
        case 1:
          return "#c1b6b1"
        case 2:
          return "#eb4d86"
      }
    },
    // 点击换一换回调
    changeIndex() {
      this.currentIndex >= 2 ? this.currentIndex = 0 : this.currentIndex += 1;
      console.log(this.currentIndex)
      this.currentDisplayList = this.changeList(this.currentIndex)
    },
    // 获取榜单数据列表
    getTopList() {
      getCourseTopList().then(res => {
        this.topList = res.data.map((item, index) => {
          return {
            ...item,
            index: index + 1
          }
        })
        this.currentDisplayList = this.changeList(this.currentIndex)
        console.log(this.currentDisplayList)
      })
    },
    // 榜单数据处理
    changeList(index) {
      //   根据索引去拿数据
      switch (index) {
        case 0:
          return this.topList.slice(0, 3);
        case 1:
          return this.topList.slice(3, 6);
        case 2:
          return this.topList.slice(6, 9);
      }
    },
    // 获取直播列表
    getLiveList() {
      liveCourseInfoList(this.livePageParams).then((res) => {
        if (res.code === SUCCESS) {
          this.liveOnlineList = res.rows;
          this.activeIndex = 0;
          this.livePageParams.total = res.total
        }
      })
    },
    // 直播翻页 last上一页 下一页
    liveTurnPage: debounce(function (status) {
      console.log(status)
      if (status === 'last') {
        if (this.livePageParams.pageNum == 1) return
        this.livePageParams.pageNum -= 1;
      } else {
        if (this.livePageParams.total <= this.livePageParams.pageNum * 4) return
        this.livePageParams.pageNum += 1
      }
      this.getLiveList()
    }, 200),
    buttonText(status) {
      if (status == 1) {
        return '直播中';
      } else if (status == 2) {
        return '直播结束';
      } else {
        return '尚未开播';
      }
    },
    showLeft(index) {
      this.activeIndex = index;
    },
    //去直播缓存页面
    toLiveOnlineDetail(courseId) {
      // if (this.isLoginClick()) {
      const {href} = this.$router.resolve({
        path: `other/course/online/detail/${courseId}`
      });
      window.open(href, '_blank')
      // }
    },
    //    移动端点击事件
    toMobileLiveOnlineDetail(item) {
      const {href} = this.$router.resolve({
        path: `other/course/online/detail/${item.courseId}`
      });
      window.open(href, '_blank')
    }
  },
}
</script>

<style scoped lang="less">
.course-live-online-container {
  color: #333333;
  margin-bottom: 14px;

  .title-box {
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > :first-child {
      width: 38px;
    }

    & > :nth-child(2) {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      font-size: 26px;
      color: #333333;
    }

    & > :nth-child(3) {
      margin-top: auto;
      margin-bottom: 5px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #9F9F9F;
    }
  }

  .online-left {
    background: #fff;
    min-height: 662px;
    border-radius: 20px;
    padding: 30px 20px;

    .first-line {
      align-items: center;
      justify-content: space-between;
      display: flex;


      .live-next-last-box {
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
          width: 20px;
          cursor: pointer;
        }
      }
    }

    .live-content-box {
      border-radius: 10px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);
      margin-top: 20px;
      cursor: pointer;
      .hover-img-scale-box{
        margin-left: 0;
        overflow: hidden;
        border-radius: 10px 10px 0 0;
      }
      img {
        width: 100%;
        height: 180px;
      }

      > div {
        margin-left: 20px;
        text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
        font-family: PingFangSC-Medium, PingFang SC;
      }

      & > :nth-child(2) {
        padding: 15px 0 10px 0;
        font-weight: 600;
        color: #333333;
      }

      & > :nth-child(3) {
        padding-bottom: 15px;
      }

      .progress-box {
        color: #333;

        img {
          width: 30px;
          height: 30px;
          margin-right: 3px;
        }

      }

      .end-box {
        color: #BAC2C2;
      }

      .not-start-box {
        color: #BAC2C2;
      }
    }

  }

  .online-right {
    background: #fff;
    min-height: 603px;
    border-radius: 20px;
    padding: 30px 20px;
    box-sizing: content-box;

    & > :first-child {
      width: 100%;
      justify-content: start;

      img {
        margin-right: 12px;
      }

      & > :nth-child(2) {
        margin-right: 12px;
      }
    }

    .content-box {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 20px;
      height: 540px;
      background: #FFFFFF;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 20px;
      padding: 20px;
      >img{
        width: 140px;
      }
      & > :nth-child(1) {
        margin-top: -40px;
      }

      .course-box {
        margin-top: 10px;
        width: 100%;

        .left-num {
          width: 43px;
          height: 20px;
          position: absolute;
          left: 0;
          top: 0px;
          display: flex;
          background-color: red;
          justify-content: center;
          align-content: center;
          flex-wrap: wrap;
          border-radius: 10px 0 20px 0;
          color: #fff;
          font-size: 12px;
          padding-top: 0;
          z-index:401;
        }

        > div {
          width: 100%;
          display: flex;
          margin-bottom: 30px;
          cursor: pointer;
          position: relative;

          img {
            width: 170px;
            height: 100%;
            border-radius: 10px;
          }
          .hover-img-scale-box{
            overflow: hidden;
            border-radius: 10px;
            margin-right: 12px;

          }
          .title-price-box {
            padding-top: 5px;

            & > :nth-child(1) {
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              height: 39px;
              margin-bottom: 5px;
              color: #4E5054;
              display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
              overflow: hidden;
              word-break: break-all; /* break-all(允许在单词内换行。) */
              text-overflow: ellipsis; /* 超出部分省略号 */
              -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
              -webkit-line-clamp: 2; /** 显示的行数 **/
            }

            & > :nth-child(2) {
              color: #F32425;
              font-size: 20px;
              font-weight: 600;
              margin-bototm: 10px;
            }

            & > :nth-child(3) {
              font-weight: 500;
              color: #B7BBC4;
            }
          }
        }
      }

      .change-box {
        margin-top: 20px;
        width: 108px;
        height: 29px;
        background: linear-gradient(90deg, #FD952D 0%, #F1534B 100%);
        border-radius: 15px;
        color: #fff;
        font-weight: 500;
        border: none;
        cursor: pointer;
      }
    }
  }
}

.mobile-course-live-online-container {
  .title-box {
    width: 300px;
    display: flex;
    align-items: center;

    & > :first-child {
      width: 35px;
      margin-right: 5px;
    }

    & > :nth-child(2) {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
      margin-right: 8px;
    }

    & > :nth-child(3) {
      margin-top: auto;
      margin-bottom: 5px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #9F9F9F;
    }

  }

  .mobile-live-list-container {
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 12px;

    .first-line {
      display: flex;
      justify-content: space-between;
      align-items: center;

    }

    .live-next-last-box {
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        width: 16px;
        cursor: pointer;
      }
    }

    .live-content-box {
      border-radius: 10px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);
      margin-top: 20px;
      width: 100%;

      .img-box {
        width: 100%;
        padding-top: 55%;
        position: relative;

        img {
          border-radius: 8px;
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
          height: 100%;
        }
      }

      & > :nth-child(2) {
        padding: 5px 10px 4px 8px;
        font-weight: 600;
        color: #333333;
        overflow: hidden; // 溢出隐藏
        white-space: nowrap; // 强制一行
        text-overflow: ellipsis; // 文字溢出显示省略号
      }

      & > :nth-child(3) {
        padding: 0 8px 8px 8px;
      }

      .progress-box {
        color: #333;

        img {
          width: 30px;
          height: 30px;
          margin-right: 3px;
        }

      }

      .end-box {
        color: #BAC2C2;
      }

      .not-start-box {
        color: #BAC2C2;
      }
    }
  }

  .mobile-course-top-list {
    margin-top: 16px;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 12px;

    .online-right {
      background: #fff;
      border-radius: 20px;
      box-sizing: content-box;

      & > :first-child {
        width: 100%;
        justify-content: start;

        img {
          margin-right: 12px;
        }

        & > :nth-child(2) {
          margin-right: 12px;
        }
      }

      .content-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 20px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        padding: 20px;
        img{
          width: 100px;
        }
        & > :nth-child(1) {
          margin-top: -40px;
        }

        .course-box {
          margin-top: 10px;
          width: 100%;

          .left-num {
            width: 43px;
            height: 20px;
            position: absolute;
            left: 0;
            top: 0px;
            display: flex;
            background-color: red;
            justify-content: center;
            align-content: center;
            flex-wrap: wrap;
            border-radius: 8px 0 20px 0;
            color: #fff;
            font-size: 12px;
            padding-top: 0;
          }

          .list-item {
            width: 100%;
            display: flex;
            margin-bottom: 30px;
            cursor: pointer;
            position: relative;
              img {
                border-radius: 8px;
                width: 130px;
                height: 94px;
                margin-right: 8px;
              }
            &>:nth-child(3) {
              padding-top: 5px;

              & > :nth-child(1) {
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                height: 39px;
                margin-bottom: 5px;
                color: #4E5054;
                display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
                overflow: hidden;
                word-break: break-all; /* break-all(允许在单词内换行。) */
                text-overflow: ellipsis; /* 超出部分省略号 */
                -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
                -webkit-line-clamp: 2; /** 显示的行数 **/
              }

              & > :nth-child(2) {
                color: #F32425;
                font-size: 20px;
                font-weight: 600;
                margin-bototm: 10px;
              }

              & > :nth-child(3) {
                font-weight: 500;
                color: #B7BBC4;
              }
            }
          }
        }

        .change-box {
          width: 108px;
          height: 29px;
          background: linear-gradient(90deg, #FD952D 0%, #F1534B 100%);
          border-radius: 15px;
          color: #fff;
          font-weight: 500;
          border: none;
          cursor: pointer;
        }
      }
    }

  }

}


</style>
